import { TableHeaderType } from "../types/TableHeaderType";
export const VmComponentsHeader: TableHeaderType[] = [
       {
      label:'Name',
      key: 'name',
      id: 'name',
      sortable: true,
    },
    {
      id: 'componentType.name',
      label: 'CmponentType',
      sortable: true,
      key: 'componentType.name',
    },
   
    {
      id: 'creationDate',
      label: 'CreationDate',
      sortable: true,
      key: 'creationDate',
    },
    
  ];